import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`In this section you will open the Turbonomic Target configuration`}</p>
    <h2>{`🚀 STEP: Turbonomic Target configuration`}</h2>
    <p>{`In this section you will open the Turbonomic Target configuration`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Click on the Turbonomic button to go to the overview`}</p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/41_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You will see the Turbonomic Homepage`}</p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/40_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click on `}<inlineCode parentName="p">{`Settings`}</inlineCode></p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/48_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click on `}<inlineCode parentName="p">{`Target Configuration`}</inlineCode></p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/42_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You will see the list of already existing Targets`}</p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/43_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
    </ol>
    <InlineNotification kind="info" mdxType="InlineNotification"> 
      <p><strong parentName="p">{`Existing Targets`}</strong></p>
      <p>{`The local Kubernetes Cluster has already been added by default.`}</p>
    </InlineNotification>
    <h2>{`🚀 STEP: Get the Target Credetials`}</h2>
    <p>{`If you are not following this as part of an IBM training course, you will have access to some demo credentials to get you started via the Training Activation Portal.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Go to the following page:`}</p>
        <a href="https://ibm.biz/training-activation" target="_blank">🚀 Training Activation Portal</a>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Login with the Access Information `}<strong parentName="p">{`provided by the Course Trainer`}</strong>{`:`}</p>
        <ul parentName="li">
          <li parentName="ul">{`Course ID`}</li>
          <li parentName="ul">{`EMail Address`}</li>
          <li parentName="ul">{`Course Password`}</li>
        </ul>
        <img parentName="li" {...{
          "src": "./../images/instana/instana_install_02.png",
          "alt": "instana"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click on the orange `}<inlineCode parentName="p">{`Additonal Info for Training`}</inlineCode>{` button`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Keep this information page open for the next steps.`}</p>
      </li>
    </ol>
    <h2>{`🚀 STEP: Create AWS Target Configuration`}</h2>
    <p>{`In this section you will create a Target for AWS `}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Click on `}<inlineCode parentName="p">{`New Target`}</inlineCode></p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/49_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click on `}<inlineCode parentName="p">{`Public Cloud`}</inlineCode></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click on `}<inlineCode parentName="p">{`AWS`}</inlineCode></p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/44_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Fill-in the Credentials provided by the Instructor or Activation Portal (Access key and Secret access key)`}</p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/45_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click on `}<inlineCode parentName="p">{`Add`}</inlineCode></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You shoudld see the AWS Target validating`}</p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/46_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
    </ol>
    <h2>{`🚀 STEP: Create Azure Target Configuration`}</h2>
    <p>{`Proceed as you did for the AWS Target.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Click on `}<inlineCode parentName="p">{`New Target`}</inlineCode></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click on `}<inlineCode parentName="p">{`Public Cloud`}</inlineCode></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click on `}<inlineCode parentName="p">{`Azure`}</inlineCode></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Fill-in the Credentials provided by the Instructor or Activation Portal (DIRECTORY (TENANT) ID, APPLICATION (CLIENT) ID and CLIENT SECRET KEY)`}</p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/47_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click on `}<inlineCode parentName="p">{`Add`}</inlineCode></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You should see the Azure Target validating`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`After a while you should see all targets as validated (green)`}</p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/50_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
    </ol>
    <h2>{`🚀 STEP: Create vCenter Target Configuration`}</h2>
    <p>{`Proceed as you did before.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Click on `}<inlineCode parentName="p">{`New Target`}</inlineCode></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click on \`Hypervisor`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click on `}<inlineCode parentName="p">{`vCenter`}</inlineCode></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Fill-in the Credentials provided by the Instructor or Activation Portal (ADDRESS, USERNAME, PASSWORD)`}</p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/54_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click on `}<inlineCode parentName="p">{`Add`}</inlineCode></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You should see the vCenter Target validating`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`After a while you should see all targets as validated (green)`}</p>
      </li>
    </ol>
    <InlineNotification kind="error" mdxType="InlineNotification"> 
      <p><strong parentName="p">{`Important - Data Collection takes some time`}</strong></p>
      <p>{`Data Collection can take 10-20 minutes.`}</p>
    </InlineNotification>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      